export function Badge({ label, color }: { label: string, color:string}) {
    var bordercolor = "border-slate-700";
    var textcolor = "text-slate-500";
    var colorBackground = "bg-slate-500";

    switch (color.toLowerCase()) {
        case "yellow":
            bordercolor = "border-yellow-400";
            colorBackground = "bg-yellow-300";
            break;
        case "green":
            bordercolor = "border-green-400";
            colorBackground = "bg-green-300";
            break;
        case "red":
            bordercolor = "border-rose-400";
            colorBackground = "bg-rose-200";
            textcolor = "text-rose-700";
            break;
        case "gray":
        case "grey":
            bordercolor = "border-slate-400";
            colorBackground = "bg-slate-300";
            break;
        default:
            break;
    }
    var className = "status-badge " + colorBackground + " " + bordercolor + " " + textcolor;
    return (
        <div className={className} >
            {label}
        </div>
    );
}